import React from "react"
import AdminPanelDom from "../domains/adminPanel/adminPanelDom"
import PendingPayments from "./PendingPayments"

class AdminPanelServizi extends React.Component {
  render() {
    return (
      <AdminPanelDom
        component={({ MessaggiComponent }) => (
          <PendingPayments forAdmin={true} MessaggiComponent={MessaggiComponent} />
        )}
        {...this.props}
      />
    )
  }
}
export default AdminPanelServizi
